<script setup lang="ts">
  import { Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import AccountMenuIcon from './AccountMenuIcon.vue';
  import { LOGOUT_LABEL } from '../lib/accountMenu';
  import type { ResolvedAccountLink } from '../model/types';

  interface AccountMenuProps {
    links: ResolvedAccountLink[];
  }

  defineProps<AccountMenuProps>();

  interface AccountMenuEmits {
    (e: 'logout'): void;
  }

  const emit = defineEmits<AccountMenuEmits>();

  const onLogout = (): void => {
    emit('logout');
  };
</script>

<template>
  <div
    class="account-menu"
    data-testid="header-account-menu"
  >
    <a
      v-for="link in links"
      :key="link.key"
      class="account-menu__item"
      data-testid="header-account-menu-link"
      :href="link.href"
      :target="link.external ? '_blank' : undefined"
      :rel="link.external ? 'noopener noreferrer' : undefined"
    >
      <AccountMenuIcon :name="link.key" />
      <Typo
        :variant="TypoVariant.BodyMRegular"
        tag="span"
      >
        {{ link.label }}
      </Typo>
    </a>

    <button
      type="button"
      class="account-menu__item account-menu__item--danger"
      data-testid="header-account-logout"
      @click="onLogout"
    >
      <AccountMenuIcon name="logout" />
      <Typo
        :variant="TypoVariant.BodyMRegular"
        tag="span"
      >
        {{ LOGOUT_LABEL }}
      </Typo>
    </button>
  </div>
</template>

<style scoped lang="scss">
  .account-menu {
    background-color: var(--color-bg-primary);
    border-radius: var(--rounding-s);
    box-shadow: var(--shadow-m);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: var(--spacing-xs) 0;
    width: 160px;

    &__item {
      align-items: center;
      background: none;
      border: none;
      color: var(--color-text-primary);
      cursor: pointer;
      display: flex;
      gap: var(--spacing-xs);
      min-height: 40px;
      padding: 0 var(--spacing-s);
      text-align: left;
      text-decoration: none;

      &:hover {
        background-color: var(--color-bg-secondary);
      }

      &--danger {
        color: var(--color-rose-60);
      }
    }
  }
</style>
